export enum DepartmentEnum {
  account = 'account',
  operation = 'operation',
  ketoan = 'ketoan',
  sup = 'sup'
}

export enum OrderByEnum {
  fullname = 'fullname',
  created_at = 'created_at',
  updated_at = 'updated_at',
}

export enum OrderTypeEnum {
  asc = 'asc',
  desc = 'desc'
}

export type StaffFullTimeItemTypes = {
  staffFullTimeData: {
    id: number,
    fullname: string,
    idCardNumber: string,
    department: Array<DepartmentEnum>,
    dob: string,
    idCardIssuedAt?: string,
    idCardIssuedBy?: string,
    permanentAddress?: string,
    team?: string,
    phoneNumber?: string,
    createdAt: string,
    updatedAt: string
  },
  user?: {
    id: number,
    name: string,
  }
};

export type StaffFullTimeParamsTypes = {
  fullname: string,
  department?: Array<string>,
  idCardNumber: string,
  idCardIssuedAt: string,
  idCardIssuedBy: string,
  permanentAddress: string,
  team?: string,
  phoneNumber: string,
  dob: string,
  userId?: number | null
};

export type StaffFullTimeDetailTypes = {
  staffFullTimeData?: {
    fullname: string,
    department?: Array<string>,
    idCardNumber: string,
    idCardIssuedAt: string,
    idCardIssuedBy: string,
    permanentAddress: string,
    team: string,
    phoneNumber: string,
    dob: string,
    userId: number
  },
  userData?: {
    id: number,
    name: string,
    email: string
  }
};
